import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

export interface AreaDto {
  id: number;
  code: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
}

export interface CreateAreaDto {
  name: string;
  isActive: boolean;
}

export interface UpdateAreaDto {
  name: string;
  sortOrder: number;
  isActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class AreaManagementService {
  private readonly apiUrl = `${environment.apiUrl}/areas`;

  constructor(private readonly http: HttpClient) {}

  getAll(includeInactive = true): Observable<AreaDto[]> {
    return this.http.get<AreaDto[]>(this.apiUrl, { params: { includeInactive } });
  }

  getActive(): Observable<AreaDto[]> {
    return this.getAll(false);
  }

  getById(id: number): Observable<AreaDto> {
    return this.http.get<AreaDto>(`${this.apiUrl}/${id}`);
  }

  create(dto: CreateAreaDto): Observable<AreaDto> {
    return this.http.post<AreaDto>(this.apiUrl, dto);
  }

  update(id: number, dto: UpdateAreaDto): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  updateSortOrder(ids: number[]): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/sort-order`, { ids });
  }
}
